import { authService } from "@/lib/auth-service";
import { getAdminToken } from "@/lib/api-client";

export const logUsage = async (action: string, details: any = {}) => {
    // Session cookies are sent automatically, no need for manual token
    // Just check if user is authenticated
    const isAuthenticated = authService.isAuthenticated();

    if (!isAuthenticated) {
        // Silent - user not authenticated
        return;
    }

    try {
        const targetUrl = new URL('/api/log-usage', window.location.origin).toString();
        // Skip console log in production or if needed to reduce noise
        // console.log(`[Logger] Sending usage log: ${action} to ${targetUrl}`, details);
        const res = await fetch(targetUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include', // Session cookie sent automatically
            body: JSON.stringify({ action, details })
        });

        if (!res.ok) {
            // Try to get error details
            try {
                const errData = await res.json();
                console.warn('Usage logging failed:', errData);
            } catch {
                // Failed to parse error, ignore
                console.warn('Usage logging failed with status:', res.status);
            }
        }
    } catch (err) {
        // Silent fail for logging to avoid disrupting user experience
        console.warn('Usage logging error:', err);
    }
};
